import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
const TokenKey = 'admin-token'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 如果请求配置了 noAuth 为 true，则跳过添加 Authorization 头（用于登录/注册等）
    if (config.noAuth) {
      return config
    }
    const token = store.getters.token || localStorage.getItem(TokenKey)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // blob/arraybuffer 直接放行（例如导出 Excel）
    const rt = response && response.config && response.config.responseType
    if (rt === 'blob' || rt === 'arraybuffer') {
      return response
    }

    const res = response && response.data
    // 统一从多个可能的位置尝试读取后端返回的消息
    const serverMessage = (res && (res.message || (res.data && res.data.message))) || null

    if (res && res.code === 200) {
        return res
    } else {
        Message.error(serverMessage || '请求失败')
        if (res && res.code === 401) {
            // token 过期或未授权，执行登出并跳转到登录页
            try {
              store.dispatch('user/logout')
            } catch (e) {
              // ignore
            }
            router.push('/login')
        }
        return Promise.reject(new Error(serverMessage || '请求失败'))
    }
  },
  error => {
    console.error('响应错误:', error)
    // 网络或服务器错误，兼容不同后端返回结构
    const status = error.response && error.response.status
    const respData = error.response && error.response.data
    const msg = (respData && (respData.message || respData.msg)) || error.message || '网络错误'
    Message.error(msg)
    if (status === 401) {
        try {
            store.dispatch('user/logout')
        } catch (e) {
            // ignore
        }
    }

    return Promise.reject(error)
  }
)

export default service
